<template>
  <a-modal :title="modalTitle" :visible="visible" :width="isViewMode ? 800 : 600" :footer="null" @cancel="onClose">
    <!-- 评价表单模式 -->
    <div v-if="!isViewMode">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
        <a-form-model-item label="评价" prop="score">
          <star-rating v-model="form.score" :show-text="true" />
        </a-form-model-item>
        <a-form-model-item label="更多感受" prop="content">
          <a-textarea v-model="form.content" placeholder="这里还可以补充更多感受哦~" :max-length="500" :rows="4" :show-count="true" />
        </a-form-model-item>
      </a-form-model>
      <div class="form-actions">
        <a-button type="primary" :loading="loading" @click="onSubmit">提交</a-button>
        <a-button style="margin-left: 8px" @click="onClose">取消</a-button>
      </div>
    </div>

    <!-- 评价列表模式 -->
    <div v-else>
      <a-table :loading="loading" :pagination="pagination" :columns="columns" size="middle" :data-source="evaluationList" row-key="id" @change="handlePageChange">
        <template slot="avatar" slot-scope="record">
          <user-profiles v-if="record.userId" :value="[record.userId]" avatar />
        </template>
        <template slot="rating" slot-scope="record">
          <star-rating :value="record.rating" :readonly="true" />
        </template>
        <template slot="comments" slot-scope="record">
          <div class="evaluation-content">{{ record.comments || '--' }}</div>
        </template>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import { submitRequirementEvaluation, queryRequirementEvaluations } from '@/api/business/requirement';
import StarRating from './StarRating.vue';

const columns = [
  {
    title: '评价人',
    width: 80,
    scopedSlots: { customRender: 'avatar' }
  },
  {
    title: '评价',
    width: 200,
    scopedSlots: { customRender: 'rating' }
  },
  {
    title: '更多感受',
    scopedSlots: { customRender: 'comments' }
  },
  {
    title: '评价时间',
    width: 220,
    dataIndex: 'createdTime'
  }
];

export default {
  components: { StarRating },
  props: {
    dataSource: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      isViewMode: false, // false: 评价表单模式, true: 评价列表模式
      form: {
        score: 3,
        content: ''
      },
      rules: {
        score: [
          { required: true, message: '请选择评价', trigger: 'change' },
          { type: 'number', min: 0, max: 5, message: '评价分数应在0-5分之间', trigger: 'change' }
        ]
      },
      evaluationList: [],
      columns,
      pagination: {
        size: 'small',
        total: 0,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: total => `共 ${total} 条`
      }
    };
  },
  computed: {
    modalTitle() {
      return this.isViewMode ? '评价列表' : '需求评价邀请';
    }
  },
  methods: {
    onOpen(viewMode = false) {
      this.visible = true;
      this.isViewMode = viewMode;

      if (viewMode) {
        // 查看评价列表模式
        this.loadEvaluationList();
      } else {
        // 评价表单模式
        this.resetForm();
      }
    },

    onClose() {
      this.visible = false;
      this.resetForm();
    },

    resetForm() {
      this.form = {
        score: 3,
        content: ''
      };
      this.$nextTick(() => {
        this.$refs.form?.clearValidate();
      });
    },

    async onSubmit() {
      try {
        await this.$refs.form.validate();
        this.loading = true;

        await submitRequirementEvaluation({
          brId: this.dataSource.id,
          score: this.form.score,
          content: this.form.content
        });

        this.$message.success('评价提交成功！');
        this.onClose();
        this.$emit('saveOk');
      } catch (error) {
        console.error('提交评价失败：', error);
        this.$message.error('提交评价失败，请重试');
      } finally {
        this.loading = false;
      }
    },

    async loadEvaluationList() {
      this.loading = true;
      try {
        const res = await queryRequirementEvaluations({
          brId: this.dataSource.id,
          pageSize: this.pagination.pageSize,
          pageNumber: this.pagination.current || 1
        });
        console.log(res);
        this.evaluationList = res.data.items || [];
        this.pagination.total = res.data.total || 0;
      } catch (error) {
        console.error('获取评价列表失败：', error);
        this.$message.error('获取评价列表失败');
        this.evaluationList = [];
      } finally {
        this.loading = false;
      }
    },

    handlePageChange(pagination) {
      this.pagination = pagination;
      this.loadEvaluationList();
    }
  }
};
</script>

<style lang="less" scoped>
.form-actions {
  text-align: right;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.evaluation-content {
  max-width: 200px;
  word-break: break-word;
  white-space: pre-wrap;
}

/deep/ .ant-form-item {
  margin-bottom: 16px;
}
</style>
